import React from 'react'
import { useSelector } from 'react-redux'

import DirectDealSummaryDetailAmount from './DirectDealSummary.detail.amount'
import DirectDealSummaryDetailBuyer from './DirectDealSummary.detail.buyer'
import DirectDealSummaryDetailLawsuit from './DirectDealSummary.detail.lawsuit'
import DirectDealSummaryDetailTable from './DirectDealSummary.detail.table'
import DirectDealSummaryDetailRequirement from './DirectDealSummary.detail.requirement'

import { Grid } from '../DirectDealSummary.styles'

/**
 * The DirectDealSummary's details.
 */
const DirectDealSummaryDetail = () => {
  const { attachments, lawsuitAmount, loading, sheet } = useSelector(state => state.directDealSummary)

  return (
    <Grid container spacing={2} margin="0">
      <Grid item md={8} xs={12}>
        <DirectDealSummaryDetailTable infoAttachments={attachments?.payload} loading={loading} sheet={sheet} />
      </Grid>
      <Grid item md xs={12}>
        <DirectDealSummaryDetailBuyer loading={loading} sheet={sheet} />
        <DirectDealSummaryDetailAmount loading={loading} sheet={sheet} />
        <DirectDealSummaryDetailLawsuit lawsuitAmount={lawsuitAmount?.lawsuits} loading={loading} sheet={sheet} />
        <DirectDealSummaryDetailRequirement loading={loading} sheet={sheet} />
      </Grid>
    </Grid>
  )
}

export default DirectDealSummaryDetail
